module.exports = __webpack_public_path__ + "img/txt_info2.a4af082b.png";